import {
  Button as SpendeskButton,
  Modal as SpendeskModal,
} from "@dev-spendesk/grapes";

export const DeleteModal = ({
  isDeleteModalOpen,
  setIsDeleteModalOpen,
  handleRemoveProcess,
  processId,
}) => (
  <SpendeskModal
    isOpen={isDeleteModalOpen}
    actions={[
      <SpendeskButton
        key="no"
        onClick={() => setIsDeleteModalOpen(false)}
        text="No, close this window!"
        variant="secondary"
      />,
      <SpendeskButton
        key="yes"
        text="Yes"
        variant="primary"
        onClick={() => handleRemoveProcess(processId)}
      />,
    ]}
    iconName="trash"
    title="Are you sure you want to delete this company?"
    variant="primary"
  />
);
